module.exports = __webpack_public_path__ + "img/chart-setting-3.51838ca2.png";